import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./Settings.module.css";
import ActivityLog from "../ActivityLog";

const WebhookActivityLogsTab = React.memo(function WebhookActivityLogsTab({
  selectedLocation,
}) {
  return (
    <Box>
      <Box className={styles.sectionHeader}>
        <Typography variant="h6" className={styles.sectionTitle}>
          Webhook Activity Logs
        </Typography>
      </Box>
      <ActivityLog
        location={selectedLocation}
        defaultView="webhook"
        forceModule="payment_webhook"
        hideSummary
        hideViewToggle
        hideModuleFilter
      />
    </Box>
  );
});

export default WebhookActivityLogsTab;
